module.exports = __webpack_public_path__ + "img/money.293ae86a.png";